import NProgress from 'nprogress'
import router from './router'
import { NO_REDIRECT_WHITE_LIST } from '@/constants'
import { useAppStoreWithOut } from '@/store/modules/app'
import { useUserStoreWithOut } from '@/store/modules/user'
import { hasAnyPermission } from '@/utils/permission'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false })

/** 刷新后从持久化恢复的 store 中可能尚未加载权限码，按需补一次 */
const ensurePermissionsLoaded = async () => {
  const userStore = useUserStoreWithOut()
  if (userStore.isAuthenticated && !userStore.permissionsLoaded) {
    await userStore.loadPermissions()
  }
}

export const setupPermission = async () => {
  const userStore = useUserStoreWithOut()

  // 应用启动时若已登录且未加载权限码，先尝试补一次（刷新场景）
  try {
    await ensurePermissionsLoaded()
  } catch {
    /* swallow; 后续 beforeEach 会再次尝试，失败时会清会话并回登录页 */
  }

  router.beforeEach(async (to) => {
    NProgress.start()
    useAppStoreWithOut().pageLoading = true

    if (!userStore.isAuthenticated) {
      if (NO_REDIRECT_WHITE_LIST.includes(to.path)) return true
      return { path: '/login', query: { redirect: to.fullPath } }
    }

    if (to.path === '/login') return { path: '/' }

    try {
      await ensurePermissionsLoaded()
    } catch {
      // 加载权限失败通常意味着 token 已失效，回到登录页。
      // 这里必须同时清空本地会话：只跳 /login 的话 isAuthenticated 仍为 true，
      // 上面 `to.path === '/login'` 那一跳会把登录页再弹回首页，
      // 形成「首页 ↔ 登录页」无限互跳，每次互跳都会重新请求一次权限接口。
      userStore.clearSession()
      return { path: '/login', query: { redirect: to.fullPath } }
    }

    // 路由级权限拦截：未命中任意所需权限码时跳 /404，避免暴露原因
    const required = to.meta?.permission as string | string[] | undefined
    if (required && !hasAnyPermission(required, userStore.permissionCodes)) {
      return { path: '/404' }
    }

    if (to.name === 'Fallback') return { path: '/404', replace: true }
    return true
  })

  router.afterEach(() => {
    NProgress.done()
    useAppStoreWithOut().pageLoading = false
  })
}